export default __webpack_public_path__ + "4597213bfd601b2e34a5816675e70099.svg";